<div id="top"></div>
<div class="container-fluid p-0">
    <!--Navbar-->
    <div class="topnav" id="myTopnav">

        <div class="container">
            <a class="navbar-brand mb-4">
                <img src="/assets/Image/logo.png" alt="" width="250" height="70">
            </a>
            <div class="nav mt-4" id="nav">
                <a id="home" routerLink="" (click)="topFunction()" (click)="closeNav()" title="Home">HOME</a>
                <a id="adv" (click)="closeNav()" class="active" title="Adventures">ADVENTURES</a>
                <a id="attr" (click)="toAttr()" (click)="closeNav()" title="Our Attractions">ATTRACTIONS</a>
                <a id="trans" (click)="toTrans()" (click)="closeNav()" title="Our Transportation">TRANSPORTATION</a>
                <a id="accom" (click)="toAccom()" (click)="closeNav()" title="Our Accommodation">ACCOMMODATIONS</a>
                <a id="food" (click)="toFood()" (click)="closeNav()" title="Our Food & Beverage">FOOD & BEV</a>

                <a id="contact" routerLink="../contact" (click)="closeNav()" title="Contact">CONTACT</a>

                <!--<a id="images" routerLink="" class="store" (click)="topFunction()" (click)="closeNav()"
                    title="Store">Store</a>-->

                <a href="javascript:void(0);" class="icon" (click)="myFunction()" id="responsive">
                    <i class="fa fa-bars"></i>
                </a>
            </div>
        </div>
    </div>

    <!--/.Navbar-->

    <!--Nav Background Image-->


    <!--BG Image-->
    <div id="wrapper">
        <!--Text-->
        <h2 class="text"><b><I>ATTRACTIONS AND MORE</I></b></h2>
        <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Places you might
                like.</i></p>

        <!--Button-->
        <a (click)="toAttr()"><button class="btn">ADVENTURE</button></a>
    </div>

    <div class="bg"></div>
    <!--BG Image-->

    <!--/.Nav Background Image-->


    <!--Attractions-->
    <div id="toAttr"></div>
    <div class="container" style="padding-top: 50px;">
        <div class="title">
            <h2 style="font-size: 30px;">PLACES YOU MIGHT LIKE</h2>
            <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Most visited
                    places</i></p>
        </div>

        <div class="row justify-content-center" style="margin-top: 30px; text-align: center;">

            <!-- Card-->
            <div class="col-sm-6 pb-2" *ngFor="let img of attractions">
                <!--Main-->
                <div class="cards">
                    <div class="titled">
                        <h4 style="font-size: 20px;"> <b>{{img.title}}</b></h4>
                        <p style="font-size: 18px; color: #f79c09ce; font-family: cursive; "><i>Attractions mostly
                                visited...</i></p>
                    </div>

                    <div class="view overlay">
                        <img [src]="img.imgUrl" class="img-fluid" alt="Sample image with waves effect."
                            (click)="basicModal.show()">
                        <a>
                            <div class="mask waves-effect waves-light rgba-white-slight" mdbWavesEffect>
                            </div>

                            <a>
                                <div (click)="basicModal.show()" class="mask waves-effect waves-light rgba-white-slight"
                                    mdbWavesEffect>
                                </div>

                                <!--Popup-->
                                <div mdbModal #basicModal="mdbModal" class="modal fade bottom" tabindex="-1"
                                    role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-scrollable" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <button type="button" class="close pull-right" aria-label="Close"
                                                    (click)="basicModal.hide()">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <h4 class="modal-title w-100" id="myModalLabel">{{img.title}}</h4>
                                            </div>
                                            <div class="modal-body">
                                                <img [src]="img.imgUrl" class="img-fluid"
                                                    alt="Sample image with waves effect.">
                                                <p style="padding-top: 30px;">
                                                    {{img.descrip}}
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!--Popup-->
                            </a>

                        </a>

                    </div>
                    <div class="containers">
                        <p align="center" style="color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Click on
                                the image to find out more. </i>
                        </p>
                    </div>
                </div>
                <!--Main-->

            </div>
            <!-- \.Card-->
        </div>
    </div>
    <!--/.Attractions-->

    <!--Transportation-->
    <div id="toTrans" class="about">
        <div class="container" style="padding-top: 50px;">
            <div class="title">
                <h2 style="font-size: 30px;">TRANSPORTATION</h2>
                <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Some of the
                        transportation</i></p>
            </div>

            <div class="row justify-content-center" style="margin-top: 30px; text-align: center;">

                <!-- Image-->
                <div class="col-sm-6 pb-2" *ngFor="let img of transport">
                    <!-- Card -->

                    <!--Main-->
                    <div class="cards">
                        <div class="titled">
                            <h4 style="font-size: 20px;"> <b>{{img.title}}</b></h4>
                            <p style="font-size: 18px; color: #f79c09ce; font-family: cursive; "><i>Transportation
                                    We
                                    offer...</i></p>
                        </div>

                        <div class="view overlay">
                            <img [src]="img.imgUrl" class="img-fluid" alt="Sample image with waves effect.">
                            <a>
                                <div class="mask waves-effect waves-light rgba-white-slight" mdbWavesEffect>
                                </div>
                            </a>

                            <a>
                                <div (click)="basicModal.show()" class="mask waves-effect waves-light rgba-white-slight"
                                    mdbWavesEffect>
                                </div>

                                <!--Popup-->
                                <div mdbModal #basicModal="mdbModal" class="modal fade bottom" tabindex="-1"
                                    role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-scrollable" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <button type="button" class="close pull-right" aria-label="Close"
                                                    (click)="basicModal.hide()">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <h4 class="modal-title w-100" id="myModalLabel">{{img.title}}</h4>
                                            </div>
                                            <div class="modal-body">
                                                <img [src]="img.imgUrl" class="img-fluid"
                                                    alt="Sample image with waves effect.">
                                                <p style="padding-top: 30px;">
                                                    {{img.descrip}}
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!--Popup-->
                            </a>
                        </div>
                        <div class="containers">
                            <p align="center" style="color: #f79c09ce; font-family: cursive; font-size: 16px;">
                                <i>Click on the image to find out more. </i>
                            </p>
                        </div>
                    </div>
                    <!--Main-->


                </div>
                <!-- Image-->
            </div>
        </div>
    </div>
    <!--/.Transportation-->


    <!--Accommodation-->
    <div id="toAccom"></div>
    <div class="container" style="padding-top: 50px;">
        <div class="title">
            <h2 style="font-size: 30px;">ACCOMMODATIONS</h2>
            <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Most visited
                    accommodations</i></p>
        </div>

        <div class="row justify-content-center" style="margin-top: 30px; text-align: center;">

            <!-- Card-->
            <div class="col-sm-6 pb-2" *ngFor="let img of accommodation">
                <!--Main-->
                <div class="cards">
                    <div class="titled">
                        <h4 style="font-size: 20px;"> <b>{{img.title}}</b></h4>
                        <p style="font-size: 18px; color: #f79c09ce; font-family: cursive; "><i>Accommodations that are
                                mostly visited...</i></p>
                    </div>

                    <div class="view overlay">
                        <img [src]="img.imgUrl" class="img-fluid" alt="Sample image with waves effect."
                            (click)="basicModal.show()">
                        <a>
                            <div class="mask waves-effect waves-light rgba-white-slight" mdbWavesEffect>
                            </div>

                            <a>
                                <div (click)="basicModal.show()" class="mask waves-effect waves-light rgba-white-slight"
                                    mdbWavesEffect>
                                </div>

                                <!--Popup-->
                                <div mdbModal #basicModal="mdbModal" class="modal fade bottom" tabindex="-1"
                                    role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-scrollable" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <button type="button" class="close pull-right" aria-label="Close"
                                                    (click)="basicModal.hide()">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <h4 class="modal-title w-100" id="myModalLabel">{{img.title}}</h4>
                                            </div>
                                            <div class="modal-body">
                                                <img [src]="img.imgUrl" class="img-fluid"
                                                    alt="Sample image with waves effect.">
                                                <p style="padding-top: 30px;">
                                                    {{img.descrip}}
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!--Popup-->
                            </a>

                        </a>

                    </div>
                    <div class="containers">
                        <p align="center" style="color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Click on
                                the image to find out more. </i>
                        </p>
                    </div>
                </div>
                <!--Main-->

            </div>
            <!-- \.Card-->
        </div>
    </div>
    <!--/.Accommodation-->


    <!--Food Joint-->
    <div id="toFood" class="about">
        <div class="container" style="padding-top: 50px;">
            <div class="title">
                <h2 style="font-size: 30px;">FOOD & BEVERAGE</h2>
                <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Some of the
                        food and beverage joints.</i></p>
            </div>

            <div class="row justify-content-center" style="margin-top: 30px; text-align: center;">

                <!-- Image-->
                <div class="col-sm-6 pb-2" *ngFor="let img of food">
                    <!-- Card -->

                    <!--Main-->
                    <div class="cards">
                        <div class="titled">
                            <h4 style="font-size: 20px;"> <b>{{img.title}}</b></h4>
                            <p style="font-size: 18px; color: #f79c09ce; font-family: cursive; "><i>Food & Beverage
                                    Places
                                    We
                                    offer...</i></p>
                        </div>

                        <div class="view overlay">
                            <img [src]="img.imgUrl" class="img-fluid" alt="Sample image with waves effect.">
                            <a>
                                <div class="mask waves-effect waves-light rgba-white-slight" mdbWavesEffect>
                                </div>
                            </a>

                            <a>
                                <div (click)="basicModal.show()" class="mask waves-effect waves-light rgba-white-slight"
                                    mdbWavesEffect>
                                </div>

                                <!--Popup-->
                                <div mdbModal #basicModal="mdbModal" class="modal fade bottom" tabindex="-1"
                                    role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-scrollable" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <button type="button" class="close pull-right" aria-label="Close"
                                                    (click)="basicModal.hide()">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <h4 class="modal-title w-100" id="myModalLabel">{{img.title}}</h4>
                                            </div>
                                            <div class="modal-body">
                                                <img [src]="img.imgUrl" class="img-fluid"
                                                    alt="Sample image with waves effect.">

                                                <p style="padding-top: 30px;">
                                                    {{img.descrip}}
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!--Popup-->
                            </a>
                        </div>
                        <div class="containers">
                            <p align="center" style="color: #f79c09ce; font-family: cursive; font-size: 16px;">
                                <i>Click on the image to find out more. </i>
                            </p>
                        </div>
                    </div>
                    <!--Main-->


                </div>
                <!-- Image-->
            </div>
        </div>
    </div>
    <!--/.Food Joint-->


    <!-- Footer -->
    <footer class="page-footer font-small">

        <!-- Footer Elements -->
        <div class="container">

            <!-- Grid row-->
            <div class="row">

                <!-- Grid column -->
                <div class="col-md-12 py-5">
                    <div class="mb-5 flex-center">

                        <!-- Facebook -->
                        <a class="fb-ic">
                            <mdb-icon fab icon="facebook" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>
                        <!-- Twitter -->
                        <a class="tw-ic">
                            <mdb-icon fab icon="twitter" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>
                        <!-- Google +-->
                        <a class="gplus-ic">
                            <mdb-icon fab fab icon="google-plus" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>

                        <!--Instagram-->
                        <a class="ins-ic">
                            <mdb-icon fab icon="instagram" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>

                    </div>
                </div>
                <!-- Grid column -->

            </div>
            <!-- Grid row-->

        </div>
        <!-- Footer Elements -->

        <!-- Copyright -->
        <div class="footer-copyright text-center py-3">© 2021 Copyright
        </div>
        <!-- Copyright -->

    </footer>
    <!-- Footer -->

    <button (click)="topFunction()" id="myBtn" title="Go to top"><i class="fas fa-arrow-up"></i></button>
</div>